import { ROUTE_ABS_DOCUMENTS_EDOCUMENTS_LIST } from '@constants/routes';

// DOM ids used as onboarding-tour anchors on the sidebar. Derived from what the nav descriptors
// already carry — a section's `id` and a leaf's `href` — so no entry needs a second identifier
// that can silently drift from it. Shared between the components that render the anchor
// (`NavSectionItem`, `NavLeafItem`) and the tour step definitions that target it, the same
// contract as `orderTourAnchors`.

export const DOCUMENTS_NAV_SECTION_ID = 'documents';

export const navSectionAnchorId = (sectionId: string): string => `onboarding-nav-${sectionId}`;

export const navLeafAnchorId = (href: string): string =>
  `onboarding-nav${href.replace(/\//g, '-')}`;

export const NAV_TOUR_ANCHORS = {
  documents: navSectionAnchorId(DOCUMENTS_NAV_SECTION_ID),
  edocuments: navLeafAnchorId(ROUTE_ABS_DOCUMENTS_EDOCUMENTS_LIST),
} as const;
